import {
  Checkbox as MantineCheckbox,
  CheckboxIndicatorProps as MantineCheckboxIndicatorProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './CheckboxIndicator.module.css';

export type CheckboxIndicatorProps = Omit<
  MantineCheckboxIndicatorProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style' | 'size'
>;

export const CheckboxIndicator = forwardRef<
  HTMLDivElement,
  CheckboxIndicatorProps
>(({ ...props }, ref) => {
  return (
    <MantineCheckbox.Indicator
      ref={ref}
      unstyled
      className={styles.indicator}
      classNames={{
        indicator: styles.indicator,
        icon: styles.icon,
      }}
      {...props}
    />
  );
});

CheckboxIndicator.displayName = 'CheckboxIndicator';
